import api from '@/libs/axiosInstance'
import settingsUtility from '@/utility/settingsUtility'

export default {
    login: async function (email, password) {
        try {
            const response = await api.post('login', { email, password });
            const { data, success, emailVerificationRequired } = response.data;
            if (data && success === true) {
                if (!emailVerificationRequired) {
                    settingsUtility.methods.setLogin(data);
                    api.defaults['headers']['Authorization'] = `Bearer ${data.token}`;
                }
                return response.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    },
    initializePwdReset(payload) {
        return api.post('init-change-pwd', payload);
    },
    changePassword(payload) {
        return api.post('change-pwd', payload);
    },
    saveSettings(id, payload){
        return api.post(`accounts/${id}/settings`, payload);
    }
};
